export enum GlobalSearchSection {
  Ui = 'ui',
  Help = 'help',
  RecentSearches = 'recent-searches',
}
